// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { calendarDate } from '../../calendar-date';
import { z } from 'zod';
export const harvestSessionId = (z.number());
export const harvestSession = z.object({
    id: harvestSessionId,
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    started_at: z.date().nullable(),
    ended_at: z.date().nullable(),
    planned_date: calendarDate,
    responsible_operator_id: operatorId.nullable(),
    objectives: z.string().nullable(),
    conclusions: z.string().nullable(),
    next_steps: z.string().nullable(),
    label: z.string().nullable(),
});
export const harvestSessionInitializer = z.object({
    id: harvestSessionId.optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    started_at: z.date().optional().nullable(),
    ended_at: z.date().optional().nullable(),
    planned_date: calendarDate,
    responsible_operator_id: operatorId.optional().nullable(),
    objectives: z.string().optional().nullable(),
    conclusions: z.string().optional().nullable(),
    next_steps: z.string().optional().nullable(),
    label: z.string().optional().nullable(),
});
export const harvestSessionMutator = z.object({
    id: harvestSessionId.optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    started_at: z.date().optional().nullable(),
    ended_at: z.date().optional().nullable(),
    planned_date: calendarDate.optional(),
    responsible_operator_id: operatorId.optional().nullable(),
    objectives: z.string().optional().nullable(),
    conclusions: z.string().optional().nullable(),
    next_steps: z.string().optional().nullable(),
    label: z.string().optional().nullable(),
});
//# sourceMappingURL=HarvestSession.js.map